import React, { useEffect, useState } from "react";
import { Button, Search, Table, IconDownload } from "@veneer/core";

import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import moment from "moment";
import XLSX from "xlsx";
import { Trans } from "react-i18next";
import { withTranslation } from "react-i18next";

const SpecialCondition = (props) => {
  const configSpecialCondition = [
    {
      id: "idSharepoint",
      label: "Id",
    },
    {
      id: "customer",
      label: <Trans i18nKey="channel" />,
      filter: (
        <Search
          name="customer-search"
          onChange={(value) =>
            handleSingleFilter({
              id: "customer",
              filterValue: value,
            })
          }
        />
      ),
    },
    {
      id: "endUser",
      label: <Trans i18nKey="specialcondition.enduser" />,
      filter: (
        <Search
          name="enduserb-search"
          onChange={(value) =>
            handleSingleFilter({
              id: "endUser",
              filterValue: value,
            })
          }
        />
      ),
    },

    {
      id: "idPress",
      label: <Trans i18nKey="pressid" />,
      filter: (
        <Search
          name="idPress-search"
          onChange={(value) =>
            handleSingleFilter({
              id: "idPress",
              filterValue: value,
            })
          }
        />
      ),
    },
    { id: "startDate", label: <Trans i18nKey="specialcondition.startdate" /> },
    { id: "endDate", label: <Trans i18nKey="specialcondition.enddate" /> },
    {
      id: "specialConditionType",
      label: <Trans i18nKey="specialcondition.discounttype" />,
    },
    {
      id: "percentage",
      label: <Trans i18nKey="specialcondition.level" />,
    },
    {
      id: "minimumImp",
      label: <Trans i18nKey="bonustable.table1" />,
    },
    {
      id: "status",
      label: <Trans i18nKey="Status" />,
      filter: (
        <Search
          name="status-search"
          onChange={(value) =>
            handleSingleFilter({
              id: "status",
              filterValue: value,
            })
          }
        />
      ),
    },
    {
      id: "comments",
      label: <Trans i18nKey="comments" />,
    },
  ];

  const connectApi = new ConnectAPI();

  const [config, setConfig] = useState(configSpecialCondition);
  const [order, setOrder] = useState(config.map((c) => c.id));
  const [orderBy, setOrderBy] = useState("idSharepoint");
  const [orderType, setOrderType] = useState("descending");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const pageSize = 50;

  const [customer, setCustomer] = useState('');
  const [endUser, setEndUser] = useState('');
  const [idPress, setIdPress] = useState('');
  const [status, setStatus] = useState('');

  const exportData = () => {
    setLoadingExport(true);
    setTimeout(() => {
      let excelData = tableData;
      //console.log(excelData);

      const dataXlsx = excelData.map((item) => {
        return {
          idSharepoint: item.idSharepoint,
          channel: item.customer,
          endUser: item.endUser,
          pressId: item.idPress,
          startDate: item.startDate,
          endDate: item.endDate,
          discountType: item.specialConditionType,
          level: item.percentage,
          minimumImp: item.minimumImp,
          cpp: item.cpp,
          comments: item.comments,
          status: item.status,
        };
      });
      const ws = XLSX.utils.json_to_sheet(dataXlsx);
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format("YYYYMMDDHHmm");

      const filename = "SpecialCondition -" + date + ".xlsx";
      const ws_name = "SpecialCondition";

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);

      setLoadingExport(false);
    }, 750);
  };

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    const fetchData = async () => {
      setIsLoading(true);
      connectApi
        .get("api/Channels/specialConditions", "", dataResponseLoad)
        .catch((error) => {
          setIsLoading(false);
          Swal.fire(
            "Error " + error?.response?.status,
            error?.response?.data,
            "error"
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      data.map((item, key) => {
        item.startDate = moment(item.startDate).format("MMM/YYYY");
        item.endDate = moment(item.endDate).format("MMM/YYYY");
      });

      setTableData(data === undefined ? [] : data);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
  }, []);

  const handlePageChange = (page) => setCurrentPage(page);

  const handleOnColumnReorder = (newOrder) => {
    setOrder(newOrder);
  };

  const filteredData = filterSort(
    tableData,    
    {customer, endUser, idPress, status},
    orderBy,
    orderType
  );

  function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter =
        typeof filterValue === "object" ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });

    // sort
    return arrayFiltered.sort((a, b) => {
      const value =
        orderType === "descending"
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);

      return value;
    });
  }

  function descendingComparator(a, b, orderBy) {
    let aSort =
      typeof a[orderBy] === "object"
        ? typeof a[orderBy] === typeof (<a />)
          ? a[orderBy].props.href.toString().toUpperCase()
          : a[orderBy].props.label.toString().toUpperCase()
        : a[orderBy].toString().toUpperCase();
    let bSort =
      typeof b[orderBy] === "object"
        ? typeof b[orderBy] === typeof (<a />)
          ? b[orderBy].props.href.toString().toUpperCase()
          : b[orderBy].props.label.toString().toUpperCase()
        : b[orderBy].toString().toUpperCase();

    if (orderBy === "dateFormatted") {
      aSort = a["date"];
      bSort = b["date"];
    } else {
      if (orderBy.includes("Formatted")) {
        const orderByFormatted = orderBy.replace("Formatted", "");
        aSort = a[orderByFormatted];
        bSort = b[orderByFormatted];
      }
    }
    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const handleSingleFilter = ({ id, filterValue, table }) => {
    switch (id) {
      default:
        break;
    }
  };

  const handleSort = (_, { id, type }) => {
    setOrderBy(id);
    setOrderType(type);
    };
    //console.log('page data')
    //console.log(pagedData)
  return (
    <div>
      <br />      

      <div>
        <br />
        <div
          style={{
            backgroundColor: "#f2f2f2",
            padding: "0.5%",
          }}
        >
          <Table
            showFilters
            columnReorder
            columns={[
              {
                id: "idSharepoint",
                label: "Id",
              },
              {
                id: "customer",
                label: <Trans i18nKey="channel" />,
                filter: (
                  <Search
                    name="customer-search"
                    value={customer}
                    onChange={setCustomer}
                  />
                ),
              },
              {
                id: "endUser",
                label: <Trans i18nKey="specialcondition.enduser" />,
                filter: (
                  <Search
                    name="enduserb-search"
                    value={endUser}
                    onChange={setEndUser}
                  />
                ),
              },
              {
                id: "idPress",
                label: <Trans i18nKey="pressid" />,
                filter: (
                  <Search
                    name="idPress-search"
                    value={idPress}
                    onChange={setIdPress}
                  />
                ),
              },
              {
                id: "startDate",
                label: <Trans i18nKey="specialcondition.startdate" />,
              },
              {
                id: "endDate",
                label: <Trans i18nKey="specialcondition.enddate" />,
              },
              {
                id: "specialConditionType",
                label: <Trans i18nKey="specialcondition.discounttype" />,
              },
              {
                id: "percentage",
                label: <Trans i18nKey="specialcondition.level" />,
              },
              {
                id: "minimumImp",
                label: <Trans i18nKey="bonustable.table1" />,
              },
              {
                id: "status",
                label: <Trans i18nKey="Status" />,
                filter: (
                  <Search
                    name="status-search"
                    value={status}
                    onChange={setStatus}
                  />
                ),
              },
              {
                id: "comments",
                label: <Trans i18nKey="comments" />,
              },
            ]}
            data={pagedData}
            onColumnReorder={handleOnColumnReorder}
            onSort={handleSort}
            loading={isLoading}
            preferences={{
              defaultOrder: config.map((c) => c.id),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              },
            }}
            pagination={{
              currentPage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: filteredData.length,
            }}
            css={{
              "tr > td:nth-of-type(10)": {
                textAlign: "right",
              },
              "tr > td:nth-of-type(8)": {
                textAlign: "right",
              },
              "tr > td:nth-of-type(9)": {
                textAlign: "right",
              },
            }}
          ></Table>
          <div style={{ textAlign: "left" }}>
            <Button
              leadingIcon={<IconDownload />}
              onClick={() => {
                exportData();
              }}
              disabled={tableData === 0}
              loading={loadingExport}
              title="Download Data"
            >
              <Trans i18nKey="download" />
            </Button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default withTranslation()(SpecialCondition);
